import React from 'react';

const AddService = () => {
    return (
        <div>
            <h3 className='text-center text-5xl mt-10'>😵‍💫😵‍💫😵‍💫</h3>
        </div>
    );
};

export default AddService;